export enum Locales {
  EN = 'en',
}
